import Week from './Week';

export default Week;
